<template>
  <ModalComponent class="unit-clone-alert" :class="{ 'unit-clone-alert--error': hasError }" :show="show" clickaway>
    <Card variant="default">
      <template #header>
        <div v-if="!hasError" class="card-v2__title">{{ $t('theUnitHasBeenDuplicated') }}</div>
        <template v-else>
          <div class="card-v2__title">
            {{ $t('cannotCreateMoreX', { x: $tc('unit', 2).toLowerCase() }) }}
          </div>
          <div class="card-v2__subtitle">
            {{ $t('projectUnitLimitReached', [0]) }}
          </div>
        </template>
      </template>

      <template #thumbnail>
        <Icon :icon="`fa-pro-light:${!hasError ? 'check' : 'triangle-exclamation'}`" />
      </template>
      <template #actions>
        <ButtonComponent
          :label="$t('close')"
          :icon="['fal', 'xmark']"
          icon-placement="left"
          @click="$emit('update:show', false)"
        />
        <ButtonComponent
          v-if="!hasError"
          @click="navigate"
          theme="primary"
          :label="`${$t('show')} ${$t('thisUnit').toLowerCase()}`"
          :icon="['fal', 'arrow-right']"
        />
      </template>
    </Card>
  </ModalComponent>
</template>

<script>
import Card from '@/components/Card-v2'
import { ModalComponent } from 'vue-elder-modal'

export default {
  props: {
    value: {
      type: [Object, String],
      default: () => ({}),
    },
    show: {
      type: Boolean,
    },
  },
  methods: {
    navigate() {
      this.$emit('update:show', false)
      this.$router.push({ name: 'residential-edit', params: { id: this.value._id, step: 'basis' } })
    },
  },
  computed: {
    hasError() {
      return !this.value._id
    },
  },
  components: {
    Card,
    ModalComponent,
  },
}
</script>

<style lang="scss">
.unit-clone-alert {
  z-index: 1011 !important;
  .card-v2 {
    max-width: 600px;
    &__thumbnail {
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--dark-green);
      background: var(--light-green);
      aspect-ratio: 16 / 7;

      .kvass-icon {
        $size: 8rem;
        height: $size;
        width: $size;
      }
    }
  }

  &--error {
    .card-v2 {
      &__thumbnail {
        color: var(--error);
        background: css-alpha('error', 0.1);
      }
    }
  }
}
</style>
